import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { DateStep } from '../components/DateStep/DateStep.jsx';
import { PostsStep } from '../components/Posts/PostStep.jsx';
import { Banner } from '../components/Banner/Banner.jsx';
import { Step } from '../utils/step';
import { Prizes } from '../components/Prizes/Prizes.jsx';

import { DATE, POSTS, BANNER, PRIZES } from '../utils/constants';
import { RESTRICTED_SITE_ADMIN } from '../../../lib/utils/constants/UserTypes';

export const useSteps = () => {
  const { t } = useTranslation('campaigns');
  const { userType } = useSelector(state => state.currentUser);

  const Date = Step(
    DateStep,
    DATE,
    'dates.title',
    'dates.description',
    'dates.shortName',
    t,
  );

  const Post = Step(
    PostsStep,
    POSTS,
    'posts.title',
    'posts.description',
    'posts.shortName',
    t,
  );

  const BannerStep = Step(
    Banner,
    BANNER,
    'banner.title',
    'banner.description',
    'banner.shortName',
    t,
  );

  const PrizesStep = Step(
    Prizes,
    PRIZES,
    'prizes.title',
    'prizes.description',
    'prizes.shortName',
    t,
    true,
  );

  let steps = [Date, BannerStep, PrizesStep, Post];

  if (userType === RESTRICTED_SITE_ADMIN) {
    steps = [Date, BannerStep, Post];
  }

  return { steps };
};
